"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputLabel = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var index_1 = require("../index");
var react_1 = require("@emotion/react");
var Tooltip_1 = __importDefault(require("../Tooltip"));
var Icon_1 = __importDefault(require("../Icon"));
var getCSSRules = function () { return ({
    root: {
        display: 'block',
        '& label': {
            position: 'relative',
        },
    },
    required: {
        paddingLeft: 2,
    },
    tooltipIcon: {
        position: 'absolute',
        left: '100%',
        top: -3,
        marginLeft: 4,
        '& svg': {
            verticalAlign: 'bottom',
        },
    },
}); };
var InputLabel = function (props) {
    var styles = getCSSRules();
    var children = props.children, required = props.required, id = props.id, tooltip = props.tooltip;
    return ((0, jsx_runtime_1.jsx)(index_1.Typography, __assign({ uppercase: true, variant: "textSmall", weight: 'bold', component: 'div', margin: 'xs', css: (0, react_1.css)(styles.root), className: 'input-label' }, { children: (0, jsx_runtime_1.jsxs)("label", __assign({ htmlFor: id, className: 'input-label' }, { children: [children, required && (0, jsx_runtime_1.jsx)("span", __assign({ css: (0, react_1.css)(styles.required) }, { children: "*" }), void 0), tooltip && ((0, jsx_runtime_1.jsx)(Tooltip_1.default, __assign({ text: tooltip || '' }, { children: (0, jsx_runtime_1.jsx)("span", __assign({ css: (0, react_1.css)(styles.tooltipIcon) }, { children: (0, jsx_runtime_1.jsx)(Icon_1.default, { size: "md", name: "details" }, void 0) }), void 0) }), void 0))] }), void 0) }), void 0));
};
exports.InputLabel = InputLabel;
//# sourceMappingURL=InputLabel.js.map